import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './Grid.module.sass';

const Grid = (props) => {
  const {
    container,
    item,
    alignContent = 'normal',
    alignItems = 'stretch',
    alignSelf = 'auto',
    justify = 'flex-start',
    direction = 'row',
    wrap = 'wrap',
    margin,
    spacing = 0,
    maxWidth = false,
    xs,
    sm,
    md,
    lg,
    xl,
    onClick,
    style = {},
    classes = {},
    children,
    ...rest
  } = props;

  const gridClasses = {
    [styles.container]: container,
    [styles.item]: item,
    [styles[`align-content-${alignContent}`]]: alignContent !== 'normal',
    [styles[`align-items-${alignItems}`]]: alignItems !== 'stretch',
    [styles[`align-self-${alignSelf}`]]: alignSelf !== 'auto',
    [styles[`justify-${justify}`]]: justify !== 'flex-start',
    [styles[`direction-${direction}`]]: direction !== 'row',
    [styles[`wrap-${wrap}`]]: wrap !== 'wrap',
    [styles[`spacing-${spacing}`]]: spacing !== 0,
    [styles[`max-width-${maxWidth}`]]: !!maxWidth,
    [styles[`col-xs-${xs}`]]: !!xs,
    [styles[`col-sm-${sm}`]]: !!sm,
    [styles[`col-md-${md}`]]: !!md,
    [styles[`col-lg-${lg}`]]: !!lg,
    [styles[`col-xl-${xl}`]]: !!xl,
    [styles[`margin-${margin}`]]: !!margin,
  };

  return (
    <div className={cn(gridClasses, classes)} style={style} onClick={onClick} {...rest}>
      {children}
    </div>
  );
};

Grid.propTypes = {
  container: PropTypes.bool,
  item: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.number]),
  alignContent: PropTypes.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around']),
  alignItems: PropTypes.oneOf(['flex-start', 'center', 'flex-end', 'stretch', 'baseline']),
  alignSelf: PropTypes.oneOf(['flex-start', 'flex-end', 'center', 'baseline', 'stretch']),
  justify: PropTypes.oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly']),
  direction: PropTypes.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),
  wrap: PropTypes.oneOf(['wrap', 'nowrap', 'wrap-reverse']),
  classes: PropTypes.string,
  style: PropTypes.object,
  spacing: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]),
  maxWidth: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
  margin: PropTypes.oneOf(['auto']),
  xs: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  sm: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  md: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  lg: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  xl: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  onClick: PropTypes.func,
};

export default Grid;
